export const CHECKOUT_URL = "https://framework.impultienda.ar/checkout/glp";

export const MOCKUP_IMAGES = {
  bundle: "https://cdn.magicpatterns.com/uploads/sbNGWnyW5GWhGfPRjeFsZp/glp.png",
  bono1: "https://cdn.magicpatterns.com/uploads/nDFzoBzRhAsVGv5tHnNcNX/BONO_1_GLP.png",
  bono2: "https://cdn.magicpatterns.com/uploads/fxNKowadts1b8FQ5U2Maxo/BONO_2_GLP.png",
  bono3: "https://cdn.magicpatterns.com/uploads/eSHBLL5KTMctydibgEzumS/BONO_3_GLP.png",
  bono4: "https://cdn.magicpatterns.com/uploads/51QFdakxJ9aTfyHkMQNFKN/BONO_4_GLP.png",
  bono5: "https://cdn.magicpatterns.com/uploads/t3fu87FrFzhNRdBUqBDU5j/BONO_5_GLP.png",
  doctora:
    "https://cdn.magicpatterns.com/patterns/generated-images/e1df0f8c-74b7-4029-924d-ed3f8897d0d7.jpg",
};

export const stats = [
  { value: "+300", label: "Protocolos y algoritmos clínicos" },
  { value: "+1.200", label: "Médicos que ya confían en la Ruta" },
  { value: "2.400", label: "Horas de estudio condensadas" },
  { value: "98%", label: "Recomendarían la Ruta a un colega" },
];

export const beforeItems = [
  "Cada paciente genera una duda diferente.",
  "Buscas respuestas entre múltiples guías y artículos.",
  "No tienes certeza sobre qué GLP-1 elegir.",
  "Dudas al iniciar o aumentar la dosis.",
  "Los efectos adversos cambian tu conducta.",
  "Cada control parece empezar desde cero.",
];

export const afterItems = [
  "Sabes exactamente cuál es el siguiente paso en cada consulta.",
  "Sigues una sola Ruta Clínica basada en la evidencia más reciente.",
  "Seleccionas el medicamento adecuado según el perfil de cada paciente.",
  "Utilizas un algoritmo de titulación claro y reproducible.",
  "Dispones de protocolos de actuación para cada escenario.",
  "Monitorizas con un plan estructurado hasta el mantenimiento.",
];

export const painPoints = [
  {
    emoji: "😰",
    text: "Frente a un paciente con obesidad o diabetes, dudas si realmente cumple criterios para iniciar un GLP-1.",
  },
  {
    emoji: "⏱️",
    text: "Pierdes tiempo revisando guías, consensos y artículos para confirmar una decisión que deberías tomar en minutos.",
  },
  {
    emoji: "🤷‍♂️",
    text: "Cuando aparecen náuseas, vómitos o estreñimiento, no tienes claro si disminuir la dosis, pausar el tratamiento o cambiar de estrategia.",
  },
  {
    emoji: "📉",
    text: "Sientes que algunos pacientes abandonan el tratamiento porque no cuentas con un protocolo estandarizado de seguimiento.",
  },
  {
    emoji: "🔄",
    text: "Logras buenos resultados iniciales, pero no sabes cómo evitar el rebote o planificar el mantenimiento a largo plazo.",
  },
  {
    emoji: "📚",
    text: "Ves que cada vez más colegas dominan estos medicamentos y no quieres quedarte atrás en una de las terapias con mayor crecimiento de la medicina moderna.",
  },
];

export const tomos = [
  {
    number: "TOMO I",
    title: "La Decisión Correcta Empieza Aquí",
    description:
      "Aprende a identificar en minutos quién realmente es candidato a un GLP-1, qué estudios cambian la conducta y qué contraindicaciones nunca debes pasar por alto.",
    result:
      "Nunca volverás a preguntarte si un paciente debe iniciar o no este tratamiento.",
  },
  {
    number: "TOMO II",
    title: "Elige el GLP-1 Correcto para Cada Paciente",
    description:
      "Descubre cuándo utilizar Semaglutida, Tirzepatida o Liraglutida según el perfil clínico del paciente, con criterios claros y comparaciones prácticas.",
    result:
      "Dejarás de elegir por costumbre y empezarás a elegir con criterio clínico.",
  },
  {
    number: "TOMO III",
    title: "La Ruta Paso a Paso del Tratamiento",
    description:
      "Sigue un algoritmo de titulación diseñado para saber exactamente cómo iniciar, escalar, ajustar o modificar el tratamiento según la evolución del paciente.",
    result: "Tendrás una respuesta clara para cada etapa del tratamiento.",
  },
  {
    number: "TOMO IV",
    title: "Domina los Efectos Adversos Antes de Que Se Conviertan en un Problema",
    description:
      "Aprende protocolos de actuación inmediata para manejar náuseas, vómitos, estreñimiento y otras complicaciones sin improvisar.",
    result:
      "Actuarás con seguridad incluso en los escenarios que hoy generan más incertidumbre.",
  },
  {
    number: "TOMO V",
    title: "Optimiza la Respuesta Clínica",
    description:
      "Integra GLP-1 con otras estrategias terapéuticas, protege la masa muscular y aprende cómo obtener mejores resultados incluso en pacientes complejos.",
    result:
      "Tus pacientes alcanzarán mejores resultados con un tratamiento más completo y sostenible.",
  },
  {
    number: "TOMO VI",
    title: "Consolida el Éxito a Largo Plazo",
    description:
      "Descubre cómo mantener los resultados, prevenir el efecto rebote y acompañar al paciente más allá de la pérdida de peso inicial.",
    result:
      "Dejarás de pensar solo en iniciar el tratamiento y aprenderás a conducir todo el proceso con confianza.",
  },
];

export type Bono = {
  badge: string;
  title: string;
  intro: string;
  listTitle: string;
  items: string[];
  result: string;
  value: string;
  image?: string;
};

export const bonos: Bono[] = [
  {
    badge: "BONO #1",
    title: "Protocolo de Rescate para Efectos Adversos GLP-1™",
    intro:
      "Cuando aparezcan náuseas, vómitos, estreñimiento o intolerancia, sabrás exactamente qué hacer.",
    listTitle: "Incluye:",
    items: [
      "Algoritmos de actuación inmediata",
      "Manejo farmacológico paso a paso",
      "Cuándo disminuir la dosis",
      "Cuándo suspender el tratamiento",
      "Cuándo derivar al paciente",
      "Señales de alarma que no puedes pasar por alto",
    ],
    result:
      "La próxima vez que un paciente te llame por un efecto adverso, no tendrás que improvisar. Tendrás un protocolo listo para actuar.",
    value: "USD $39",
    image: MOCKUP_IMAGES.bono1,
  },
  {
    badge: "BONO #2",
    title: "Guía Rápida de Cambio y Titulación entre GLP-1™",
    intro:
      "Nunca más dudes al cambiar de Semaglutida a Tirzepatida o ajustar una dosis.",
    listTitle: "Aprenderás:",
    items: [
      "Cómo realizar conversiones correctamente",
      "Qué hacer cuando una marca no está disponible",
      "Cómo reiniciar tratamientos interrumpidos",
      "Cuándo acelerar o ralentizar la titulación",
    ],
    result:
      "Cada cambio de tratamiento dejará de ser una decisión basada en intuición.",
    value: "USD $49",
    image: MOCKUP_IMAGES.bono2,
  },
  {
    badge: "BONO #3",
    title: "Kit Médico-Legal para Prescripción Segura de GLP-1™",
    intro:
      "La documentación profesional que protege tanto al paciente como a tu práctica clínica.",
    listTitle: "Recibirás:",
    items: [
      "Consentimiento informado",
      "Checklist pretratamiento",
      "Registro de riesgos",
      "Advertencias clínicas",
      "Formatos de seguimiento",
    ],
    result: "Mayor tranquilidad al documentar cada decisión clínica.",
    value: "USD $59",
    image: MOCKUP_IMAGES.bono3,
  },
  {
    badge: "BONO #4",
    title: "50 Casos Clínicos Resueltos de GLP-1™",
    intro:
      "Aprende en unas horas lo que normalmente tomaría años de experiencia clínica. Casos reales de obesidad, diabetes, hígado graso, enfermedad renal, hipotiroidismo, adulto mayor, paciente que no responde, recuperación de peso y uso combinado con insulina.",
    listTitle: "Cada caso incluye:",
    items: [
      "Evaluación clínica",
      "Razonamiento médico",
      "Conducta",
      "Seguimiento",
    ],
    result:
      "Ganarás criterio clínico antes de enfrentarte a esos pacientes en consulta.",
    value: "USD $79",
    image: MOCKUP_IMAGES.bono4,
  },
  {
    badge: "BONO #5",
    title: "Protocolo para Maximizar Resultados y Preservar Masa Muscular™",
    intro: "Porque perder peso no siempre significa mejorar la salud.",
    listTitle: "Aprenderás cómo ayudar a tus pacientes a:",
    items: [
      "Preservar masa muscular",
      "Optimizar la ingesta proteica",
      "Reducir el riesgo de sarcopenia",
      "Mantener resultados a largo plazo",
    ],
    result:
      "Pacientes con una pérdida de peso de mayor calidad y mejores resultados clínicos.",
    value: "USD $49",
    image: MOCKUP_IMAGES.bono5,
  },
];

export const offerRows = [
  { label: "Ruta Clínica GLP-1™ (6 Tomos Clínicos)", value: "USD $197" },
  { label: "Bono #1 · Protocolo de Rescate", value: "USD $39" },
  { label: "Bono #2 · Cambio y Titulación", value: "USD $49" },
  { label: "Bono #3 · Kit Médico-Legal", value: "USD $59" },
  { label: "Bono #4 · 50 Casos Clínicos", value: "USD $79" },
  { label: "Bono #5 · Masa Muscular", value: "USD $49" },
];

export const testimonials = [
  {
    quote:
      "Antes dudaba cada vez que un paciente preguntaba por Ozempic. Hoy sigo una ruta clara desde la primera consulta hasta el seguimiento. Me dio una seguridad que no había encontrado en ningún curso.",
    name: "María C.",
    role: "Médica General",
    country: "Colombia 🇨🇴",
    avatar:
      "https://cdn.magicpatterns.com/patterns/generated-images/827f6c68-2246-4c72-b6fb-99f7287ba154.jpg",
  },
  {
    quote:
      "El algoritmo de titulación por sí solo vale más que el precio completo del programa. Ahora sé exactamente cuándo subir, mantener o modificar una dosis.",
    name: "José R.",
    role: "Medicina Interna",
    country: "México 🇲🇽",
    avatar:
      "https://cdn.magicpatterns.com/patterns/generated-images/6a1bb4b0-d64f-49d5-9cb4-7aca509961dd.jpg",
  },
  {
    quote:
      "Los casos clínicos fueron el punto de inflexión. Sentí que adquirí años de experiencia clínica en muy poco tiempo.",
    name: "Andrea S.",
    role: "Endocrinóloga",
    country: "España 🇪🇸",
    avatar:
      "https://cdn.magicpatterns.com/patterns/generated-images/5b2e46db-3932-4c7f-bcbb-f9dcf0a216e8.jpg",
  },
  {
    quote:
      "Todo está organizado para usarlo durante la consulta. Ya no pierdo tiempo buscando información entre distintas guías.",
    name: "Luis M.",
    role: "Médico Familiar",
    country: "Argentina 🇦🇷",
    avatar:
      "https://cdn.magicpatterns.com/patterns/generated-images/ab685ab6-b71d-47aa-9aea-784d13e9365c.jpg",
  },
];

export const faqs = [
  {
    question: "¿Cómo recibo el material?",
    answer:
      "Inmediatamente después del pago recibirás un correo con acceso a todos los tomos y bonos. Podrás descargarlos y consultarlos desde cualquier dispositivo.",
  },
  {
    question: "¿Funciona para médicos de cualquier país?",
    answer:
      "Sí. La Ruta Clínica está basada en las principales guías internacionales (ADA, AACE, EASD y otras referencias relevantes) y utiliza un español neutro. Además, incluye equivalencias de marcas comerciales por región cuando corresponde.",
  },
  {
    question: "¿Los materiales son digitales?",
    answer:
      "Sí. Todo el contenido se entrega en formato PDF de alta calidad, optimizado para computadora, tablet y teléfono.",
  },
  {
    question: "¿Debo pagar una suscripción?",
    answer: "No. Realizas un único pago y el acceso es tuyo para siempre.",
  },
  {
    question: "¿Está dirigido solo a especialistas?",
    answer:
      "No. Fue diseñado para médicos generales y especialistas que desean incorporar el uso de GLP-1 a su práctica clínica con mayor seguridad y una metodología clara.",
  },
];

export const purchaseNotifications = [
  { name: "Valeria G.", city: "Bogotá", country: "Colombia" },
  { name: "Andrés M.", city: "Ciudad de México", country: "México" },
  { name: "Lucía F.", city: "Madrid", country: "España" },
  { name: "Martín P.", city: "Buenos Aires", country: "Argentina" },
  { name: "Camila R.", city: "Santiago", country: "Chile" },
  { name: "Diego T.", city: "Lima", country: "Perú" },
  { name: "Sofía L.", city: "Montevideo", country: "Uruguay" },
  { name: "Ricardo V.", city: "Quito", country: "Ecuador" },
  { name: "Daniela S.", city: "San José", country: "Costa Rica" },
  { name: "Javier A.", city: "Guadalajara", country: "México" },
  { name: "Paula N.", city: "Barcelona", country: "España" },
  { name: "Fernando C.", city: "Asunción", country: "Paraguay" },
];
